import { mapActions, mapGetters } from 'vuex';
import Tooltip from '@/components/Tooltip/index.vue';

export default {
  name: 'ColorPicker',
  components: {
    Tooltip,
  },
  computed: {
    ...mapGetters([
      'getOptionListByType',
      'getAllOptionItems',
      'getOptions',
      'getProductBySku',
      'getActiveProductTabs',
      'getPartNumber',
    ]),
    optionsList() {
      return this.getOptionListByType('image');
    },
  },
  data() {
    return {
      preloadedSkus: [],
    };
  },
  methods: {
    setFiltersGaAttr(href) {
      return `EMS - Filter, click, ${href}`;
    },
    ...mapActions([
      'updateProductData',
      'setProductActiveTabId',
    ]),
    getImages(imageCategory) {
      return this.getAllOptionItems(imageCategory);
    },
    calculateLinkClass(image) {
      return {
        app__color__picker__link__active: image.enabled,
        js__active: image.enabled,
        app__color__picker__link__selected: image.selected,
        js__selected: image.selected,
      };
    },
    async changeColor(item) {
      // update the product data
      await this.updateProductData(item.sku);
    },
    preloadImages(item) {
      // If we already preloaded it or is the current product do nothing
      if (this.preloadedSkus[item.sku] || this.getPartNumber === item.sku) return;

      const productDetails = this.getProductBySku(item.sku);

      // We want the default image and the rest of the gallery
      const images = [
        productDetails.images.defaultImage,
        ...productDetails.images.gallery,
      ];

      // Do the actual preloading
      images.forEach((imgObj) => {
        const img = new Image();
        img.src = imgObj.image;
      });

      // Add the SKU to preloaded ones
      this.preloadedSkus[item.sku] = true;
    },
  },
};
